// extracted by mini-css-extract-plugin
export default {"header":"BQ-z","isActive":"CQ-z"};